const CONFIRMABLE = ['restaurant_placed'];
const CANCELLABLE = ['restaurant_placed', 'approved'];

/**
 * Ops stand in for the supplier until a supplier app exists (backend spec §5.6):
 * a placed order can be confirmed or cancelled, a confirmed one only cancelled.
 * Takes the RAW status from the API — the details screen rewrites `approved`
 * to `modified` and `rejected` to `canceled` for display, which must not hide
 * the buttons.
 */
export function opsOrderActions(
  rawStatus: string | undefined,
  canManage: boolean
): { canConfirm: boolean; canCancel: boolean } {
  if (!canManage || !rawStatus) return { canConfirm: false, canCancel: false };

  return {
    canConfirm: CONFIRMABLE.includes(rawStatus),
    canCancel: CANCELLABLE.includes(rawStatus),
  };
}
